import { EnKeysProps } from './en';

export const en: EnKeysProps = {};
